import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const initialState = {
  subscriptionId: null,
  currentCall: null,
  loading: {
    refusing: false,
    accepting: false,
  },
};

const callListenerModule = {
  namespaced: true,

  state: initialState,
  mutations,
  actions,
  getters,
};

export default callListenerModule;
